import { useNavigate } from "react-router-dom";
import { useQueryParams as useQuery, UseQueryParams } from "@stemscopes/api";

const useQueryParams: UseQueryParams = (props) => {
  const navigate = useNavigate();

  return useQuery({ updateLocation: navigate, ...props });
};

export default useQueryParams;
